var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["macros/utils.j2"] = require( "macros/utils.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/rrTray.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/macros/rrTray.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
env.getTemplate("macros/utils.j2", false, "core/templates/macros/rrTray.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("create_attr")) {
var t_8 = t_5.create_attr;
} else {
cb(new Error("cannot import 'create_attr'")); return;
}
context.setVariable("create_attr", t_8);
env.getTemplate("macros/urls.j2", false, "core/templates/macros/rrTray.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("productUrl")) {
var t_12 = t_9.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_12);
if(t_9.hasOwnProperty("contentfulUrl")) {
var t_13 = t_9.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_13);
output += "\n\n";
var macro_t_14 = runtime.makeMacro(
[], 
["anEntry", "rrRecs", "isRightRail", "isDy"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("anEntry", kwargs.hasOwnProperty("anEntry") ? kwargs["anEntry"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("rrRecs", kwargs.hasOwnProperty("rrRecs") ? kwargs["rrRecs"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("isRightRail", kwargs.hasOwnProperty("isRightRail") ? kwargs["isRightRail"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isDy", kwargs.hasOwnProperty("isDy") ? kwargs["isDy"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_15 = "";t_15 += "\n\n    <span class=\"dom-rr-container\">\n        ";
t_15 += "\n        ";
var t_16;
t_16 = (lineno = 10, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["anEntry.fields.recommendationPlacementId",(lineno = 10, colno = 89, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["anEntry.fields.richRelevancePlacementId",runtime.contextOrFrameLookup(context, frame, "None")]))]));
frame.set("placementIdFromEntry", t_16, true);
if(frame.topLevel) {
context.setVariable("placementIdFromEntry", t_16);
}
if(frame.topLevel) {
context.addExport("placementIdFromEntry", t_16);
}
t_15 += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "anEntry") && runtime.contextOrFrameLookup(context, frame, "placementIdFromEntry")) {
t_15 += "\n            ";
var t_17;
t_17 = runtime.contextOrFrameLookup(context, frame, "placementIdFromEntry");
frame.set("placement", t_17, true);
if(frame.topLevel) {
context.setVariable("placement", t_17);
}
if(frame.topLevel) {
context.addExport("placement", t_17);
}
t_15 += "\n            ";
var t_18;
t_18 = env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "placement"),".","__");
frame.set("placementKey", t_18, true);
if(frame.topLevel) {
context.setVariable("placementKey", t_18);
}
if(frame.topLevel) {
context.addExport("placementKey", t_18);
}
t_15 += "\n            ";
var t_19;
t_19 = (lineno = 15, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.rrRecs." + "" + runtime.contextOrFrameLookup(context, frame, "placementKey")]));
frame.set("rrRecs", t_19, true);
if(frame.topLevel) {
context.setVariable("rrRecs", t_19);
}
if(frame.topLevel) {
context.addExport("rrRecs", t_19);
}
t_15 += "\n        ";
;
}
else {
if(!runtime.contextOrFrameLookup(context, frame, "rrRecs") && env.getFilter("length").call(context, env.getFilter("keys").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"rrRecs"))) == 1) {
t_15 += "\n            ";
var t_20;
t_20 = env.getFilter("first").call(context, env.getFilter("keys").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"rrRecs")));
frame.set("onlyKey", t_20, true);
if(frame.topLevel) {
context.setVariable("onlyKey", t_20);
}
if(frame.topLevel) {
context.addExport("onlyKey", t_20);
}
t_15 += "\n            ";
var t_21;
t_21 = env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "onlyKey"),"__",".");
frame.set("placement", t_21, true);
if(frame.topLevel) {
context.setVariable("placement", t_21);
}
if(frame.topLevel) {
context.addExport("placement", t_21);
}
t_15 += "\n            ";
var t_22;
t_22 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"rrRecs")),runtime.contextOrFrameLookup(context, frame, "onlyKey"));
frame.set("rrRecs", t_22, true);
if(frame.topLevel) {
context.setVariable("rrRecs", t_22);
}
if(frame.topLevel) {
context.addExport("rrRecs", t_22);
}
t_15 += "\n        ";
;
}
;
}
t_15 += "\n\n        ";
var t_23;
t_23 = runtime.contextOrFrameLookup(context, frame, "isDy") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"isDy");
frame.set("dynamicYield", t_23, true);
if(frame.topLevel) {
context.setVariable("dynamicYield", t_23);
}
if(frame.topLevel) {
context.addExport("dynamicYield", t_23);
}
t_15 += "\n        ";
var t_24;
t_24 = (lineno = 23, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isFeatureEnabled"), "isFeatureEnabled", context, [runtime.contextOrFrameLookup(context, frame, "core"),"favorites"]));
frame.set("displayFavorites", t_24, true);
if(frame.topLevel) {
context.setVariable("displayFavorites", t_24);
}
if(frame.topLevel) {
context.addExport("displayFavorites", t_24);
}
t_15 += "\n\n        <div class=\"\n            js-rr-container";
if(runtime.contextOrFrameLookup(context, frame, "isSwiper")) {
t_15 += " s-product-tray-swiper";
;
}
else {
t_15 += " s-product-tray-grid ";
;
}
if((lineno = 28, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productMeta"]))) {
t_15 += " s-product-you-may-also-like js-product-you-may-also-like ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "dynamicYield")) {
t_15 += " js-dy-recommendations ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "slidesPerView") == 3) {
t_15 += " s-product-you-may-also-like--secondary-placement ";
;
}
t_15 += "\"\n            ";
if(runtime.contextOrFrameLookup(context, frame, "placement")) {
t_15 += "data-rr-placement=\"";
t_15 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "placement"), env.opts.autoescape);
t_15 += "\"";
;
}
t_15 += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "slidesPerView")) {
t_15 += "data-slides-per-view=\"";
t_15 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "slidesPerView"), env.opts.autoescape);
t_15 += "\"";
;
}
t_15 += "\n            data-qa-recs\n            data-index=";
t_15 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
t_15 += "\n        >";
if(runtime.contextOrFrameLookup(context, frame, "rrRecs")) {
var t_25;
t_25 = env.getFilter("replace").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"placement"),".","");
frame.set("rrPlacementClean", t_25, true);
if(frame.topLevel) {
context.setVariable("rrPlacementClean", t_25);
}
if(frame.topLevel) {
context.addExport("rrPlacementClean", t_25);
}
t_15 += "<div class=\"o-row\">\n\n                    <div class=\"o-column o-extra-small--12 o-slider-product-tray__heading-outer\">\n\n                        <h3 class=\"o-slider-product-tray__h3\">";
if(runtime.contextOrFrameLookup(context, frame, "dynamicYield")) {
var t_26;
t_26 = "dy_" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"strategyName");
frame.set("strategySlug", t_26, true);
if(frame.topLevel) {
context.setVariable("strategySlug", t_26);
}
if(frame.topLevel) {
context.addExport("strategySlug", t_26);
}
;
}
else {
var t_27;
t_27 = "rr_strategyName-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"strategyName");
frame.set("strategySlug", t_27, true);
if(frame.topLevel) {
context.setVariable("strategySlug", t_27);
}
if(frame.topLevel) {
context.addExport("strategySlug", t_27);
}
;
}
t_15 += runtime.suppressValue((lineno = 58, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "strategySlug"),runtime.makeKeywordArgs({"orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
t_15 += "\n\n                        </h3>\n\n                        ";
var t_28;
t_28 = (lineno = 62, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "rrRecs"),"seeMoreUrl"]));
frame.set("seeMoreLink", t_28, true);
if(frame.topLevel) {
context.setVariable("seeMoreLink", t_28);
}
if(frame.topLevel) {
context.addExport("seeMoreLink", t_28);
}
t_15 += "\n                        ";
var t_29;
t_29 = (lineno = 63, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "rrRecs"),"seeMoreTitle"]));
frame.set("seeMoreTitle", t_29, true);
if(frame.topLevel) {
context.setVariable("seeMoreTitle", t_29);
}
if(frame.topLevel) {
context.addExport("seeMoreTitle", t_29);
}
t_15 += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "seeMoreLink")) {
t_15 += "\n                            <span class=\"o-slider-product-tray__more-link-outer\">\n\n                                <a\n                                    href=\"";
t_15 += runtime.suppressValue((lineno = 68, colno = 56, runtime.callWrap(t_13, "contentfulUrl", context, [runtime.contextOrFrameLookup(context, frame, "seeMoreLink")])), env.opts.autoescape);
t_15 += "\"\n                                    class=\"o-slider-product-tray__more-link\"\n                                    data-qa-see-more-link>\n\n                                    ";
t_15 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "seeMoreTitle")?runtime.contextOrFrameLookup(context, frame, "seeMoreTitle"):(lineno = 72, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-tray_see-more"]))), env.opts.autoescape);
t_15 += "\n\n                                </a>\n\n                            </span>\n                        ";
;
}
t_15 += "\n\n                    </div>\n\n                </div>\n\n                <div class=\"o-row\">\n                    ";
var t_30;
t_30 = runtime.contextOrFrameLookup(context, frame, "isSwiper") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"recs")) > runtime.contextOrFrameLookup(context, frame, "slidesPerView");
frame.set("showSliderArrows", t_30, true);
if(frame.topLevel) {
context.setVariable("showSliderArrows", t_30);
}
if(frame.topLevel) {
context.addExport("showSliderArrows", t_30);
}
t_15 += "\n\n                    <div class=\"o-column o-extra-small--12 ";
if(runtime.contextOrFrameLookup(context, frame, "isSwiper")) {
t_15 += "o-slider-product-tray__wrapper";
;
}
else {
t_15 += "u-no-gutters";
;
}
if(runtime.contextOrFrameLookup(context, frame, "showSliderArrows")) {
t_15 += " o-slider-product-tray__wrapper--has-arrows";
;
}
t_15 += " js-rr-grid js-rr-placement-";
t_15 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"placement"), env.opts.autoescape);
t_15 += "\" data-qa-rr-grid\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"feedId")) {
t_15 += "data-dy-feed-id=\"";
t_15 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"feedId"), env.opts.autoescape);
t_15 += "\"";
;
}
t_15 += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"widgetId")) {
t_15 += "data-dy-widget-id=\"";
t_15 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"widgetId"), env.opts.autoescape);
t_15 += "\"";
;
}
t_15 += ">\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "isSwiper")) {
t_15 += "\n\n                            <div class=\"o-slider-product-tray o-slider-product-tray--product-image u-centered-content js-slider--product-image js-modal-product-image-zoom-fix ";
if(!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"isShopTheLook") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"recs")) < 4 || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"isShopTheLook") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"recs")) < 7) {
t_15 += " ";
;
}
t_15 += " o-slider-product-tray__full\">\n\n                                <div class=\"o-slider-product-tray__inner js-slider-product-tray__inner\">\n\n                        ";
;
}
else {
t_15 += "\n\n                            <div class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "isRightRail")) {
t_15 += "o-block-grid";
;
}
t_15 += "\">\n\n                        ";
;
}
t_15 += "\n\n                        ";
frame = frame.push();
var t_33 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"recs");
if(t_33) {var t_32 = t_33.length;
for(var t_31=0; t_31 < t_33.length; t_31++) {
var t_34 = t_33[t_31];
frame.set("product", t_34);
frame.set("loop.index", t_31 + 1);
frame.set("loop.index0", t_31);
frame.set("loop.revindex", t_32 - t_31);
frame.set("loop.revindex0", t_32 - t_31 - 1);
frame.set("loop.first", t_31 === 0);
frame.set("loop.last", t_31 === t_32 - 1);
frame.set("loop.length", t_32);
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"maxTileCount") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") <= runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"maxTileCount")) {
t_15 += "\n\n                                ";
var t_35;
t_35 = (lineno = 107, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.analytics.productTypeSlug"]));
frame.set("brandAnalyticsSlug", t_35, true);
if(frame.topLevel) {
context.setVariable("brandAnalyticsSlug", t_35);
}
if(frame.topLevel) {
context.addExport("brandAnalyticsSlug", t_35);
}
t_15 += "\n\n                                ";
t_15 += "\n                                ";
var t_36;
t_36 = "PAGE_TYPE";
frame.set("rrEventCategory", t_36, true);
if(frame.topLevel) {
context.setVariable("rrEventCategory", t_36);
}
if(frame.topLevel) {
context.addExport("rrEventCategory", t_36);
}
t_15 += "\n                                ";
var t_37;
t_37 = runtime.memberLookup((t_34),"product");
frame.set("tile", t_37, true);
if(frame.topLevel) {
context.setVariable("tile", t_37);
}
if(frame.topLevel) {
context.addExport("tile", t_37);
}
t_15 += "\n                                ";
var t_38;
t_38 = (lineno = 112, colno = 65, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "tile"),"product.productSlug"]));
frame.set("rrEventLabel", t_38, true);
if(frame.topLevel) {
context.setVariable("rrEventLabel", t_38);
}
if(frame.topLevel) {
context.addExport("rrEventLabel", t_38);
}
t_15 += "\n                                ";
var t_39;
t_39 = "dy rec tray " + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"strategyName") + "|" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("rrEventAction", t_39, true);
if(frame.topLevel) {
context.setVariable("rrEventAction", t_39);
}
if(frame.topLevel) {
context.addExport("rrEventAction", t_39);
}
t_15 += "\n                                ";
var t_40;
t_40 = (t_34?(lineno = 114, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "rrEventCategory"),runtime.contextOrFrameLookup(context, frame, "rrEventAction") + "|click",runtime.contextOrFrameLookup(context, frame, "rrEventLabel")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("rrAnalytics", t_40, true);
if(frame.topLevel) {
context.setVariable("rrAnalytics", t_40);
}
if(frame.topLevel) {
context.addExport("rrAnalytics", t_40);
}
t_15 += "\n                                ";
var t_41;
t_41 = (t_34?(lineno = 115, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "rrEventCategory"),runtime.contextOrFrameLookup(context, frame, "rrEventAction") + "|quickshop",runtime.contextOrFrameLookup(context, frame, "rrEventLabel")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("rrAnalyticsQuickShop", t_41, true);
if(frame.topLevel) {
context.setVariable("rrAnalyticsQuickShop", t_41);
}
if(frame.topLevel) {
context.addExport("rrAnalyticsQuickShop", t_41);
}
t_15 += "\n\n                                ";
if(runtime.contextOrFrameLookup(context, frame, "isSwiper")) {
t_15 += "\n\n                                    <div class=\"o-slider-product-tray__slide o-slider-product-tray__slide--product-image js-slider-product-tray__slide\" ";
if((lineno = 119, colno = 169, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_34,"product.strId"]))) {
t_15 += "data-dy-strategy-id=\"";
t_15 += runtime.suppressValue((lineno = 119, colno = 231, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_34,"product.strId"])), env.opts.autoescape);
t_15 += "\"";
;
}
t_15 += ">\n\n                                ";
;
}
else {
t_15 += "\n\n                                    <div class=\"";
if(runtime.contextOrFrameLookup(context, frame, "isRightRail")) {
t_15 += "s-right-rail__item";
;
}
else {
t_15 += "o-block-grid__item";
;
}
t_15 += "\" ";
if((lineno = 123, colno = 132, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_34,"product.strId"]))) {
t_15 += "data-dy-strategy-id=\"";
t_15 += runtime.suppressValue((lineno = 123, colno = 194, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_34,"product.strId"])), env.opts.autoescape);
t_15 += "\"";
;
}
t_15 += ">\n\n                                ";
;
}
t_15 += "\n\n                                ";
var t_42;
t_42 = (runtime.contextOrFrameLookup(context, frame, "isRightRail")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"productTileSmallImagePreset"):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("imagePreset", t_42, true);
if(frame.topLevel) {
context.setVariable("imagePreset", t_42);
}
if(frame.topLevel) {
context.addExport("imagePreset", t_42);
}
t_15 += "\n\n                                ";
t_15 += runtime.suppressValue((lineno = 129, colno = 51, runtime.callWrap(t_4, "displayProductTile", context, [runtime.memberLookup((t_34),"product"),runtime.makeKeywordArgs({"tileTemplate": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rrRecs")),"tileTemplate"),"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"analytics": runtime.contextOrFrameLookup(context, frame, "rrAnalytics"),"analyticsQuickShop": runtime.contextOrFrameLookup(context, frame, "rrAnalyticsQuickShop"),"attributes": [(lineno = 129, colno = 216, runtime.callWrap(t_8, "create_attr", context, ["data-rr-click-tracking",runtime.memberLookup((t_34),"clickTrackingURL")]))],"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites"),"imagePreset": runtime.contextOrFrameLookup(context, frame, "imagePreset")})])), env.opts.autoescape);
t_15 += "\n\n                                ";
t_15 += "\n                                    </div>\n\n                            ";
;
}
;
}
}
frame = frame.pop();
t_15 += "\n\n                        ";
t_15 += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "isSwiper")) {
t_15 += "\n\n                                </div>\n\n                            </div>\n\n                        ";
t_15 += "\n                        ";
;
}
else {
t_15 += "\n\n                            </div>\n\n                        ";
;
}
t_15 += "\n\n                        ";
t_15 += "\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "showSliderArrows")) {
env.getTemplate("macros/slider-macros.j2", false, "core/templates/macros/rrTray.j2", false, function(t_44,t_43) {
if(t_44) { cb(t_44); return; }
t_43.getExported(context.getVariables(), frame, function(t_45,t_43) {
if(t_45) { cb(t_45); return; }
if(t_43.hasOwnProperty("create_slider_arrows")) {
var t_46 = t_43.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
frame.set("create_slider_arrows", t_46);
t_15 += runtime.suppressValue((lineno = 158, colno = 49, runtime.callWrap(t_46, "create_slider_arrows", context, [runtime.makeKeywordArgs({"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True"),"classPrefix": "slider-product-tray"})])), env.opts.autoescape);
t_15 += "\n\n                        ";
})});
}
t_15 += "\n                        ";
t_15 += "\n\n                    </div>\n\n                </div>";
;
}
t_15 += "</div>\n\n    </span>\n";
;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
context.addExport("richRelevanceTray");
context.setVariable("richRelevanceTray", macro_t_14);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/rrTray.j2"] , dependencies)